import React from "react";

const CagnotteComeInWidget = React.lazy(
  () => import("./CagnotteComeInWidget/CagnotteComeInWidget")
);

const AboutComeInWidget = React.lazy(
  () => import("@src/components/widgets/components/AboutComeInWidget")
);
const AboutCornerWidget = React.lazy(
  () => import("@src/components/widgets/components/AboutCornerWidget")
);
const AboutNavByDesireWidget = React.lazy(
  () => import("@src/components/widgets/components/AboutNavByDesireWidget")
);
const AdvancedTemplatingWidget = React.lazy(
  () => import("@src/components/widgets/components/AdvancedTemplatingWidget")
);
const BannerWidget = React.lazy(
  () => import("@src/components/widgets/components/BannerWidget")
);
const CategoriesWidget = React.lazy(
  () => import("@src/components/widgets/components/CategoriesWidget")
);
const FAQWidget = React.lazy(
  () => import("@src/components/widgets/components/FAQWidget")
);
const GlossaryWidget = React.lazy(
  () => import("@src/components/widgets/components/GlossaryWidget")
);
const InstagramWidget = React.lazy(
  () => import("@src/components/widgets/components/InstagramWidget")
);
const JobWidget = React.lazy(
  () => import("@src/components/widgets/components/JobWidget")
);
const LandingWidget = React.lazy(
  () => import("@src/components/widgets/components/LandingWidget")
);
const MenuWidget = React.lazy(
  () => import("@src/components/widgets/components/MenuWidget")
);
const NewsWidget = React.lazy(
  () => import("@src/components/widgets/components/NewsWidget")
);
const PageHeaderWidget = React.lazy(
  () => import("@src/components/widgets/components/PageHeaderWidget")
);
const ProductListWidget = React.lazy(
  () => import("@src/components/widgets/components/ProductListWidget")
);
const ProductsHighlightWidget = React.lazy(
  () => import("@src/components/widgets/components/ProductsHighlightWidget")
);
const ReinsuranceWidget = React.lazy(
  () => import("@src/components/widgets/components/ReinsuranceWidget")
);
const RichTextWidget = React.lazy(
  () => import("@src/components/widgets/components/RichTextWidget")
);
const SEOWidget = React.lazy(
  () => import("@src/components/widgets/components/SEOWidget")
);
const SponsorshipWidget = React.lazy(
  () => import("@src/components/widgets/components/SponsorshipWidget")
);
const TitleWidget = React.lazy(
  () => import("@src/components/widgets/components/TitleWidget")
);
const VoucherSMSWidget = React.lazy(
  () => import("@src/components/widgets/components/VoucherSMSWidget")
);
const LandingStandardWidget = React.lazy(
  () => import("./LandingStandardWidget/LandingStandardWidget")
);
const MySushiShopWidget = React.lazy(
  () => import("./MySushiShopWidget/MySushiShopWidget")
);

export const widgetComponents = {
  AboutComeInWidget,
  AboutCornerWidget,
  AboutNavByDesireWidget,
  AdvancedTemplatingWidget,
  BannerWidget,
  CategoriesWidget,
  FAQWidget,
  GlossaryWidget,
  InstagramWidget,
  JobWidget,
  LandingWidget,
  MenuWidget,
  NewsWidget,
  PageHeaderWidget,
  ProductListWidget,
  ProductsHighlightWidget,
  ReinsuranceWidget,
  RichTextWidget,
  SEOWidget,
  SponsorshipWidget,
  TitleWidget,
  VoucherSMSWidget,
  LandingStandardWidget,
  CagnotteComeInWidget,
  MySushiShopWidget,
};

export type WidgetComponentName = keyof typeof widgetComponents;
